import api from '../axiosConfig';

export interface VerificationHistoryItem {
    request_id: string;
    service_name: string;
    user_name: string;
    status: string | null;
    error_message: string | null;
    created_at: string | null;
}

export interface VerificationHistoryList {
    items: VerificationHistoryItem[];
    total: number;
    page: number;
    page_size: number;
}

export interface VerificationHistoryDetail {
    request_id: string;
    service_name: string;
    user_name: string;
    status: string | null;
    error_message: string | null;
    created_at: string | null;
    request_data: Record<string, unknown> | null;
    report_data: Record<string, unknown> | null;
}

export interface VerificationHistoryUser {
    id: string;
    username: string;
}

export interface HistoryFilters {
    service?: string;
    userId?: string;
    dateFrom?: string;
    dateTo?: string;
}

const BASE = '/verification/history';

export const verificationHistoryService = {
    getHistory: async (
        page: number = 1,
        pageSize: number = 20,
        filters?: HistoryFilters,
    ): Promise<VerificationHistoryList> => {
        const params: Record<string, string | number> = { page, page_size: pageSize };
        if (filters?.service) params.service = filters.service;
        if (filters?.userId) params.user_id = filters.userId;
        if (filters?.dateFrom) params.date_from = filters.dateFrom;
        if (filters?.dateTo) params.date_to = filters.dateTo;
        const response = await api.get(BASE, { params });
        return response.data;
    },

    getUsers: async (): Promise<VerificationHistoryUser[]> => {
        const response = await api.get(`${BASE}/users`);
        return response.data;
    },

    getDetail: async (
        requestId: string,
        serviceName: string,
    ): Promise<VerificationHistoryDetail> => {
        const response = await api.get(`${BASE}/${requestId}`, {
            params: { service: serviceName },
        });
        return response.data;
    },

    downloadHistory: async (
        format: 'pdf' | 'csv' | 'excel' = 'csv',
        filters?: HistoryFilters,
    ): Promise<Blob> => {
        const params: Record<string, string | number> = { format };
        if (filters?.service) params.service = filters.service;
        if (filters?.userId) params.user_id = filters.userId;
        if (filters?.dateFrom) params.date_from = filters.dateFrom;
        if (filters?.dateTo) params.date_to = filters.dateTo;
        
        const response = await api.get(`${BASE}/download`, { 
            params,
            responseType: 'blob'
        });
        return response.data;
    },
};
